export const detectSkillIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete skill" || cleaned === "remove skill") {
        return { intent: "delete_skill" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) skill/);
    if (deleteMatch) {
        return { intent: "delete_skill", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create skill") || cleaned.includes("add skill")) {
        return { intent: "create_skill" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create skill named (.+)/);
    if (createMatch) {
        return { intent: "create_skill", name: createMatch[1].trim() };
    }

    return null;
};
